import { createApp } from "vue";
import { createPinia } from "pinia";
import VueRoot from "./VueRoot.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";

loadFonts();

const pinia = createPinia();
const app = createApp(VueRoot);

app.use(router).use(vuetify).use(pinia).mount("#app");
